<template>
  <div v-if="isLoaded">

    <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div class="row" v-if="moduleInfoMessage">
        <div class="col-12">
          <div style="
                color: rgb(90, 90, 90);
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid rgb(90, 90, 90);
                margin-bottom: 20px;
                border-radius: 3px">
            {{ moduleInfoMessage }}
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div class="row" v-if="moduleErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ moduleErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <form @submit.prevent="submitForm" novalidate coaching-id="" operation-type="" protocol-id="" submit-form>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              v-model="formData.termin"
              :disabled="isBilled || isCoachBilled"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue
              v-model="formData.presence"
              :disabled="isBilled || isCoachBilled"
              :options="presenceDropdown"
              :required="true"
              label="Anwesenheit"
              placeholder="Wählen Sie Anwesenheit"
              :validation="v$.presence"
              :messages="v$.presence.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.units"
              label="Einheiten"
              disabled="disabled"/>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12">
          <SelectVue
              v-model="formData.coachType"
              :disabled="isBilled || isCoachBilled"
              :options="coachTypeDropdown"
              :required="true"
              :is-clear="true"
              label="Coachart"
              placeholder="Wählen Sie Coachart"
              :validation="v$.coachType"
              :messages="v$.coachType.required.$message"/>
        </div>
        <div class="col-6 col-lg-2 col-md-4 col-sm-12 mt-4"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <BaseCheckbox
              v-model="formData.billed"
              :disabled="isBilled || isCoachBilled"
              label="Abgerechnet"
              :labelPosition="'right'"/>
        </div>
        <div class="col-6 col-lg-1 col-md-4 col-sm-12 mt-4"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <BaseCheckbox
              v-model="formData.paid"
              :disabled="isBilled || isCoachBilled"
              label="Bezahlt"
              :labelPosition="'right'"/>
        </div>
      </div>
      <div class="row mt-3 mt-sm-0">
        <div class="col-12">
          <SelectVue
              v-model="formData.moduleId"
              :options="moduleDropdown"
              :disabled="isBilled || isCoachBilled"
              :required="true"
              :is-clear="true"
              label="Modul"
              placeholder="Modul auswählen"
              :validation="v$.moduleId"
              :messages="v$.moduleId.required.$message"
              @update:modelValue="onChangeModule"/>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput
              v-model="formData.meetingTopic"
              label="Sitzungsthema"
              :required="true"
              :validation="v$.meetingTopic"
              :messages="v$.meetingTopic.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>

      <div v-if="!moduleErrorMessage" class="d-flex justify-content-center w-100 mt-4">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>

    </form>
  </div>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalPrivateLearningCoachingService from '@/api/Portal/PrivateLearningCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs} from 'vue';
import {useI18n} from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const presenceDropdown = ref([]);
const coachTypeDropdown = ref([]);
const moduleDropdown = ref([]);
const moduleErrorMessage = ref('');
const moduleInfoMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const emit = defineEmits(['update:modelValue', 'update:submitForm']);

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: [Number, String],
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const protocolId = toRefs(props)['protocolId'];

const formData = ref({
  coachingId: '',
  termin: '',
  presence: '',
  moduleId: null,
  coachType: '',
  units: 0,
  billed: false,
  paid: false,
  meetingTopic: '',
  description: '',
});

const formRules = ref({
  termin: requiredRule(t),
  presence: requiredRule(t),
  coachType: requiredRule(t),
  units: requiredRule(t),
  meetingTopic: requiredRule(t),
  moduleId: requiredRule(t),
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    CloseToast();

    formData.value.coachingId = +coachingId.value;
    formData.value.units = Number(formData.value.units);

    if (props.protocolId) {
      await portalPrivateLearningCoachingService.putProtocol(formData.value, +protocolId.value);
    } else {
      await portalPrivateLearningCoachingService.postProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    CloseToast();
    const {data} = await portalPrivateLearningCoachingService.getProtocol(+protocolId.value);
    const moduleId = data.data?.module?.id;

    isBilled.value = data.data.invoiced;
    isCoachBilled.value = data.data.coachInvoiced;

    formData.value = {
      ...data.data,
      moduleId: moduleId,
    };
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedModules() {
  try {
    CloseToast();
    const {data} = await dropdownService.getPrivateLearningCoachingAssignedModules(+coachingId.value);
    moduleDropdown.value = data.data.map(item => ({
      label: `${item.name}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function onChangeModule(newValue) {
  try {
    if (newValue) {
      const {data} = await portalPrivateLearningCoachingService.getSumUnitsDoneForModule(
          +coachingId.value, +newValue, +protocolId.value,
      );

      moduleErrorMessage.value = data.data.errorMessage;
      moduleInfoMessage.value = data.data.infoMessage;

      formData.value.units = data.data.unitsPerMeeting;
    } else {
      moduleErrorMessage.value = '';
      moduleInfoMessage.value = '';
      formData.value.units = 0;
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getEnumsDropdown() {
  presenceDropdown.value = getEnums?.value?.presenceTypes || [];
  coachTypeDropdown.value = getEnums?.value?.portalCoachTypes || [];
}

onMounted(async () => {
  await Promise.all([
    getEnumsDropdown(),
    getAssignedModules(),
  ]);

  if (protocolId.value) {
    await getProtocolData(protocolId);
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>